import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../http/api.service';
import { RotationSaveBody, WorkShiftRotation, mapRotationFromApi } from '../../utils/work-shift-rotation.util';

/**
 * Catálogo de rotaciones de turnos (ciclos de N días, p. ej. catorcenal) — api/WorkShiftRotation.
 * Mismo alcance que los turnos: generales de la administradora + propias de un proyecto. La
 * asignación de una rotación a un contrato vive en EmployerService (Schedule/{id}/Rotation).
 */
@Injectable({
  providedIn: 'root'
})
export class WorkShiftRotationService {

  constructor(
    private api: ApiService,
    private _http: HttpClient
  ) { }

  /** Generales de la administradora del proyecto + las del proyecto, cada una con su última versión. */
  getByProject(projectId: string): Observable<WorkShiftRotation[]> {
    return this._http.get<any[]>(this.api.getUrl(`api/WorkShiftRotation/Project/${projectId}`)).pipe(
      map(list => (Array.isArray(list) ? list : []).map(mapRotationFromApi))
    );
  }

  /** Crea la versión 1 de la rotación. */
  create(body: RotationSaveBody): Observable<any> {
    return this._http.post<any>(this.api.getUrl('api/WorkShiftRotation'), body);
  }

  /** Si cambian longitud o días se crea una versión nueva; solo el nombre no versiona. */
  update(id: string, body: RotationSaveBody): Observable<any> {
    return this._http.put<any>(this.api.getUrl(`api/WorkShiftRotation/${id}`), body);
  }

  /** Inactiva = no se puede asignar; las asignaciones existentes siguen. No existe DELETE. */
  setActive(id: string, isActive: boolean): Observable<any> {
    return this._http.patch<any>(this.api.getUrl(`api/WorkShiftRotation/${id}/Active`), { isActive });
  }
}
